import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { URL } from '../../util/ambienteActions';
import { ATIVAR_VENDAS_SITE, INATIVAR_VENDAS_SITE } from '../types';

export function ativarVendaSite(codigoEmpresa, codigoItinerario) {
    const url = `${URL}/itinerario/${codigoItinerario}/empresa/${codigoEmpresa}/ativar/venda-site`;
        
    return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
        type: ATIVAR_VENDAS_SITE,
        payload: response
        })
    );
}

export function inativarVendaSite(codigoEmpresa, codigoItinerario) {
    const url = `${URL}/itinerario/${codigoItinerario}/empresa/${codigoEmpresa}/inativar/venda-site`;

    return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
        type: INATIVAR_VENDAS_SITE,
        payload: response
        })
    );
}